module.exports = __webpack_public_path__ + "static/media/billValueDark.06b596f2.svg";